<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="小区">
                <a-input
                  allowClear
                  v-model="queryParam.communityName"
                  @change="onChange"
                  @click="onSearch"
                  placeholder="请选择小区"
                />
              </a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="楼号"
                ><a-input v-model="queryParam.buildingNo" placeholder="楼号"
              /></a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="单元号"
                  ><a-input v-model="queryParam.unitNo" placeholder="单元号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="门牌号"
                  ><a-input v-model="queryParam.houseNum" placeholder="门牌号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="房号"
                  ><a-input v-model="queryParam.roomNum" placeholder="房号"
                /></a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button style="margin-left: 8px" @click="reset"
                  >重置</a-button
                >
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="action" slot-scope="text, record">
          <template>
            <a class="a-action" @click="goHouseInfo(record)">查看房源</a>
          </template>
        </span>
      </s-table>
    </a-card>

    <!-- 小区选择 -->
    <community-modal ref="comModal" @sure="selectCommunity"></community-modal>
  </page-view>
</template>
<script>
import { PageView } from "@/layouts";
import { STable } from "@/components";
import CommunityModal from "../house/stepForm/CommunityModal.vue";
export default {
  components: {
    PageView,
    STable,
    CommunityModal
  },
  name: "StarList",
  data() {
    return {
      userInfo: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        userType: this.$store.getters.userInfo.userType,
        userNo: this.$store.getters.userInfo.userNo,
        merchantNo: this.$store.getters.userInfo.merchantNo,
        communityCode: "",
        communityName: ""
      },
      // 表头
      columns: [
        {
          title: "小区名称",
          dataIndex: "communityName"
        },
        {
          title: "房源名称",
          dataIndex: "houseName"
        },
        {
          title: "楼号",
          dataIndex: "buildingNo"
        },
        {
          title: "单元号",
          dataIndex: "unitNo"
        },
        {
          title: "门牌号",
          dataIndex: "houseNum"
        },
        {
          title: "房号",
          dataIndex: "roomNum"
        },
        {
          title: "月租金",
          dataIndex: "rent"
        },
        {
          title: "收藏次数",
          dataIndex: "total"
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageHouseCollectGroup(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    reset() {
      this.queryParam.buildingNo = "";
      this.queryParam.unitNo = "";
      this.queryParam.houseNum = "";
      this.queryParam.roomNum = "";
      this.queryParam.communityCode = "";
      this.queryParam.communityName = "";
    },
    goHouseInfo(info) {
      this.$router.push({
        name: "HouseInfo",
        query: {
          houseNo: info.houseNo
        }
      });
    },
    onChange(evt) {
      this.queryParam.communityCode = "";
      this.queryParam.communityName = "";
    },
    onSearch() {
      this.$refs.comModal.show();
    },
    selectCommunity(item) {
      Object.assign(this.queryParam, item);
    }
  }
};
</script>

<style lang="less" scoped>
.actions {
  button {
    margin-right: 10px;
  }
}

/deep/ .ant-descriptions-item-content {
  overflow: hidden;
  text-overflow: ellipsis !important;
  white-space: nowrap;
}
</style>
